import React, { FC, useState }              from "react";
import { Button, Form, Icon, Input, Modal } from "semantic-ui-react";
import LoginPassword                        from "../../../domain/authentication/LoginPassword";
import ValidatorMessage                     from "../message/ValidatorMessage";

interface Props {
  onClick: (currentPassword: LoginPassword, newPassword: LoginPassword, confirmPassword: LoginPassword, callback: (value: boolean) => void) => void;
}

const PasswordChangeButton: FC<Props> = (props: Props) => {
  const [open, setOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  return (
    <>
      <Button
        onClick={ () => {
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
          setOpen(true);
        } }
      >
        パスワードを変更する
      </Button>
      <Modal
        open={ open }
      >
        <Modal.Header>パスワードを変更する</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field required>
              <label>現在のパスワード</label>
              <Input
                type="password"
                onChange={ (event, data) => setCurrentPassword(data.value) }
              />
              <ValidatorMessage target="currentPassword"/>
            </Form.Field>
            <Form.Field required>
              <label>新しいパスワード</label>
              <Input
                type="password"
                onChange={ (event, data) => setNewPassword(data.value) }
              />
              <ValidatorMessage target="newPassword"/>
              <ValidatorMessage target="validNewPassword"/>
            </Form.Field>
            <Form.Field required>
              <label>新しいパスワード(確認)</label>
              <Input
                type="password"
                onChange={ (event, data) => setConfirmPassword(data.value) }
              />
              <ValidatorMessage target="confirmPassword"/>
              <ValidatorMessage target="validNewPassword"/>
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            icon
            labelPosition="left"
            positive
            onClick={ () => props.onClick(new LoginPassword(currentPassword), new LoginPassword(newPassword), new LoginPassword(confirmPassword), setOpen) }
          >
            <Icon name="save"/>保存する
          </Button>
          <Button onClick={ () => setOpen(false) }>閉じる</Button>
        </Modal.Actions>
      </Modal>
    </>
  )
};

export default PasswordChangeButton;
